export const ROUTES = {

    LOGIN: "/",

    DASHBOARD: "/dashboard",

    MEMBERS_FORM: "/memberPage",

    MEMBERS: "/members",

    NOTES_FORM: "/notesPage",

    DEPENDANTS_FORM: "/dependantPage",

    DEPENDANTS: "/dependants",

    EXPENSE_FORM: "/expenses",

    INCOME_FORM: "/incomes",

    CLAIMS_FORM: "/claimsForm",

    PREMIUMS_FORM: "/premiumForm",

    INVESTMENTS_FORM: "/investmentForm",

    CASH_AT_HAND_FORM: "/cashAtHandForm",

    REPORTS: "/reports",

    STATEMENT_SCREEN: "/statementScreen",

    QUERY_TRANSACTIONS: "/queryTransactions"

}